export default "__VITE_ASSET__Bhh5ebxQ__"